import { __assign } from "tslib";
import React from 'react';
import { Svg } from '@marvelapp/ui';
export default function CommentIcon(props) {
    return (React.createElement(Svg, __assign({ height: "16px", viewBox: "0 0 16 16", width: "16px" }, props),
        React.createElement("path", { d: "m8 0c-4.43333333 0-8 3.13404804-8 6.99133793 0 2.20990563 1.16666667 4.17873067 2.96666667 5.46449397l.06635329 3.0433387c.02322746.4871731.35979348.6460697.75067145.3557003l2.21630859-2.0329155c.63333333.1607204 1.3.2009006 2 .2009006 4.4333333 0 8-3.134048 8-6.99133797 0-3.85728989-3.5666667-7.03151803-8-7.03151803z" })));
}
